module.exports = __webpack_public_path__ + "static/headerIcon-291e8af944b16af397f973fd2f693148.svg";